import { render, staticRenderFns } from "./PackageCourseDetail.vue?vue&type=template&id=2beff20f"
import script from "./PackageCourseDetail.vue?vue&type=script&lang=js"
export * from "./PackageCourseDetail.vue?vue&type=script&lang=js"
import style0 from "./PackageCourseDetail.vue?vue&type=style&index=0&id=2beff20f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports